module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/blog-placeholder-450.882217d51e86cbfe.png"+" 450w"+","+"https://static.sniffspot.com/packs/img/blog-placeholder-600.1b4281270b9aca8f.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/blog-placeholder-450.882217d51e86cbfe.png",width: 450,height: 289},{path: "https://static.sniffspot.com/packs/img/blog-placeholder-600.1b4281270b9aca8f.png",width: 600,height: 386}],
        src: "https://static.sniffspot.com/packs/img/blog-placeholder-600.1b4281270b9aca8f.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/blog-placeholder-600.1b4281270b9aca8f.png"},
        
        width: 600,
        height: 386
      }